import { MouseEvent, ReactElement } from 'react';
import { ROUTES } from '@client/routes/components/Router/routes';
import { useOpenLink, useUrlCreator } from '@client/routes/hooks';
import { ProductVariantsMatrix } from './ProductVariantsMatrix';
import { Props } from './ProductVariantsMatrixContainer.types';

export const ProductVariantsMatrixContainer = ({ variantsMatrix, className }: Props): ReactElement => {
  const openLink = useOpenLink();
  const urlCreator = useUrlCreator();
  const variants = variantsMatrix || [];
  const areVariants2D = Array.isArray(variants) && variants[0]?.children && variants[0].children.length > 0;

  const handleStockCountClick = (sku: string) => (e: MouseEvent<HTMLSpanElement>): void => {
    e.preventDefault();
    openLink(e, urlCreator(ROUTES.product, { sku }));
  };

  const headerData = {
    title: areVariants2D
      ? (variants[0]?.children[0]?.name || '')
      : (variants[0]?.name || ''),
    secondaryTitle: areVariants2D ? variants[0]?.name : undefined,
    options: areVariants2D
      ? variants[0]?.children.map((variantChild) => variantChild.value) || []
      : variants.map((variant) => variant.value),
  };

  const rowsData = areVariants2D
    ? variants.map((variant) => ({
      title: variant.value,
      options: variant.children.map((childRow) => ({
        value: childRow.value,
        sku: childRow.sku,
        stockInfo: childRow.stockInfo,
      })),
    }))
    : [{
      options: variants.map((variant) => ({
        value: variant.value,
        sku: variant.sku,
        stockInfo: variant.stockInfo,
      })),
    }];


  return (
    <ProductVariantsMatrix
      className={className}
      headerData={headerData}
      onStockCountClick={handleStockCountClick}
      rowsData={rowsData}
    />
  );
};
